import { useEffect, useRef, useState } from "react";
import { InventoryItem } from "../../../api/inventory/InventoryItem";
import { useLazyGetReservedQuery } from "../../../api/redemption/redemptionApi";

export function useReservedSims(orderId?: string, maxSimIdx?: number) {
  const [ret, setRet] = useState<Record<string, InventoryItem>>({});
  const [refreshFlag, setRefreshFlag] = useState(0);
  const [getReserved] = useLazyGetReservedQuery();

  const lastOid = useRef("");

  function refresh() {
    setRet({});
    setRefreshFlag((f) => f + 1);
  }

  useEffect(() => {
    if (orderId === undefined || orderId === lastOid.current) {
      return;
    }

    lastOid.current = orderId ?? "";
    setRet({});
  }, [orderId]);

  useEffect(() => {
    if (orderId === undefined || maxSimIdx === undefined) {
      return;
    }

    async function run() {
      console.log("Fetching reserved sims for" + orderId + " up to #" + maxSimIdx);
      if (orderId === undefined || maxSimIdx === undefined) {
        return;
      }
      const r: Record<string, InventoryItem> = {};
      for (let i = 1; i <= maxSimIdx; i++) {
        try {
          const res = await getReserved({
            orderId: orderId,
            simIdx: i
          }).unwrap();
          const key = orderId + "," + i;
          if (res) {
            r[key] = res;
          }
        } catch (e) {
          console.log("No reserved sim for " + orderId + " #" + i);
          console.error(e);
        }
      }

      setRet(r);
      console.log("Reserved sims:", r);
    }
    run();
  }, [orderId, maxSimIdx, getReserved, refreshFlag]);

  return { reservedSims: ret, refresh };
}